import { useEffect } from 'react';
import { useFormik } from 'formik';
import { Pqr, PqrCallInfo } from '../../../../../../shared/types/modules/pqr';
import { IRegisterUser } from '../../../../../../shared/types/auth';

export const usePqrDetailGeneralInfo = (pqr?: Pqr) => {
    const formik = useFormik({
        initialValues: {
            consecutiveFormat: '',
            created_at: '',
            status: '',
            detail: '',
            callInfo: '',
            createdBy: '',
            location: '',
            sfcId: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const {
            consecutiveFormat = '',
            created_at = '',
            callInfo: callInfoRaw = '',
            createdBy: createdByRaw = '',
            reception,
        } = pqr || {};
        const detail = pqr?.info?.detail || '';
        const callInfo =
            typeof callInfoRaw === 'string'
                ? callInfoRaw
                : (callInfoRaw as PqrCallInfo)?.callId || '';

        const createdBy = createdByRaw
            ? `${(createdByRaw as IRegisterUser)?.name} ${
                (createdByRaw as IRegisterUser)?.surname
            }`
            : reception || '';
        const status =
            typeof pqr?.info?.status === 'object' && pqr?.info?.status?.name
                ? pqr?.info.status.name
                : '';
        const formattedCreatedAt =
            created_at instanceof Date
                ? created_at.toISOString()
                : created_at || '';
        const location =
            typeof pqr?.info?.location === 'object' && pqr?.info?.location?.name
                ? pqr.info.location.name
                : '';

        formik.setValues({
            consecutiveFormat,
            created_at: formattedCreatedAt,
            detail,
            status,
            callInfo,
            createdBy,
            location,
            sfcId: pqr?.dataSfc?.sfcId || '',
        });
    }, [pqr]);

    return {
        formik,
    };
};
